const projectName =
  window.rpSettings && !!window.rpSettings.projectName
    ? window.rpSettings.projectName
    : 'rp'

const projectFullName = {
  rp: __('Resident Portal'),
  tp: __('Tenant Portal'),
  rh: __('ReservationHub'),
}

export default (boolIsFullName = false) =>
  boolIsFullName ? projectFullName[projectName] : projectName
